import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { TranslateDirective } from '@ngx-translate/core';

import { FocusDirective } from '../../components/focus/focus.directive';
import { IconComponent } from '../../components/icon/icon.component';
import { ButtonComponent } from '../../components/button/button.component';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { DetailedLoadingIndicatorComponent } from '../../components/detailed-loading-indicator/detailed-loading-indicator.component';
import { HelpArticleIndexComponent } from './help-article-index.component';
import { HelpMobileArticleComponent } from './help-mobile-article.component';
import { HelpScrollerDirective } from './help-scroller.directive';
import { Topic } from './help.domain';
import { HelpBaseComponent } from './help-base.component';

@Component({
  selector: 'td-wb-help-mobile',
  templateUrl: 'help-mobile.component.html',
  styleUrls: ['help-common.scss', 'help-mobile.component.scss'],
  imports: [
    ButtonComponent,
    TranslatePipe,
    IconComponent,
    FocusDirective,
    HelpScrollerDirective,
    HelpArticleIndexComponent,
    HelpMobileArticleComponent,
    TranslateDirective,
    DetailedLoadingIndicatorComponent
  ]
})
export class HelpMobileComponent extends HelpBaseComponent implements OnInit, OnDestroy {
  showIndex: boolean = true;
  isIOS: boolean = false;
  opened: boolean = false;

  constructor() {
    super();
    this.isIOS = inject(Platform).IOS;
  }

  ngOnInit(): void {
    this.showIndex = this.articleId === null;
    super.ngOnInit();
    this.opened = true;
  }

  close(): void {
    super.close();
    this.opened = false;
  }

  showContent(topic: Topic): false {
    this.showIndex = false;
    this.loadTopic(topic);
    return false;
  }

  closeContent(): false {
    this.showIndex = true;
    return false;
  }

  swipeLeft(): void {
    if (this.showIndex) {
      this.close();
    } else {
      this.closeContent();
    }
  }

  hasFocus(id: string): boolean {
    return id === this.articleId;
  }

  tabIndex(id: string): 0 | -1 {
    return id === this.articleId ? 0 : -1;
  }

  focusOn(indexId: string): void {
    this.articleId = undefined;
    this.helpService.scrollToLink(indexId);
  }
}
